import { NavLink } from 'react-router-dom';

export function SiteNav() {
  return (
    <nav className="navbar navbar-expand-sm navbar-light grey-background py-0">
      <div className="container d-flex justify-content-between">
        <div className="navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <NavLink className={({ isActive }) => 'nav-link py-1' + (isActive ? ' active' : '')} to="/" end>
                Home
              </NavLink>
            </li>
            <li className="nav-item"><span className="nav-link py-1">|</span></li>
            <li className="nav-item">
              <NavLink className={({ isActive }) => 'nav-link py-1' + (isActive ? ' active' : '')} to="/rankings">
                Rankings
              </NavLink>
            </li>
            <li className="nav-item"><span className="nav-link py-1">|</span></li>
            <li className="nav-item">
              <NavLink className={({ isActive }) => 'nav-link py-1' + (isActive ? ' active' : '')} to="/transparency">
                Transparency
              </NavLink>
            </li>
            <li className="nav-item"><span className="nav-link py-1">|</span></li>
            <li className="nav-item">
              <NavLink className={({ isActive }) => 'nav-link py-1' + (isActive ? ' active' : '')} to="/ghgshopper">
                GHG Shopper Reports
              </NavLink>
            </li>
            <li className="nav-item"><span className="nav-link py-1">|</span></li>
            <li className="nav-item">
              <a
                className="nav-link py-1"
                href="https://www.ghgshopper.org"
                target="_blank"
                rel="noopener noreferrer"
                title="Opens ghgshopper.org in a new tab"
              >
                GHG Shopper App
                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: '4px', verticalAlign: 'middle', opacity: 0.7 }}>
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                  <polyline points="15 3 21 3 21 9" />
                  <line x1="10" y1="14" x2="21" y2="3" />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}
